<app-header />

<ion-content>
  <div class="alfred-client-container">
    <ion-card>
      <ion-card-content>
        <lib-alfred-client
          (onCancelClick)="navigateToOverview()"
          (finished)="navigateToOverview()"
        />
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
